import { apiService } from '@/services/APIService';

export default {

  getNodeStatus(params) {
    return apiService.get('/node/status', params);
  },

  getNodeHistory(params) {
    return apiService.get('/node/history', params);
  },
  removeNode(id, params) {
    return apiService.post(`/node/remove${id}`, params);
  },
  addNode(params) {
    return apiService.post('/node/add', params);
  },
  startNode(params) {
    return apiService.post('/node/start', params);
  },
  refreshNode(params) {
    return apiService.post('/node/refresh', params);
  },

  stopNode(params) {
    return apiService.post('/node/stop', params);
  },
};
